export class ssoRecycleBinUrl {
    DELETE_RECYCLE_BIN_ORGANIZER_URL = "org/v1/recycle-bin/";
    RECYCLE_BIN_ORGANIZER_URL = "org/v1/recycle-bin/all[?ClientName][&ClientID][&TaxYear][&ERO][&BatchName][&SentBy][&DeliveredAfter][&SignatureStatus][&OrganizerStatus][&SourceDocumentStatus][&DeletedBy][&DeletedAfter][&SortBy][&SortOrder][&PageNo][&PageSize]";
    RESTORE_RECYCLE_BIN_ORGANIZER_URL = "org/v1/recycle-bin/restore";
}